import { graphql } from "gatsby"

// import BodyClass from "@components/BodyClass"
import Page from "@components/page"
import Slugify from "slugify"
import "../fragments/Page"

const PageTemplate = ({ data }) => {
  const bodyClass = data.page.css || Slugify(data.page.name, { lower: true })

  return <Page content={{ data: data }} bodyClass={bodyClass} />
}

export default PageTemplate

export const query = graphql`
  query ($contentful_id: String!) {
    page: contentfulPage(contentful_id: { eq: $contentful_id }) {
      ...Page
    }
  }
`
export { Head } from "@components/Head/Head"
